import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const listeners = new Set();

export function setBrandingLogo(logo) {
  cache = { logo };
  listeners.forEach((l) => l(cache));
}

export function useBranding() {
  const [b, setB] = useState(cache || { logo: null });
  useEffect(() => {
    listeners.add(setB);
    if (!cache) api.get("/public/branding").then((r) => setBrandingLogo(r.data.logo)).catch(() => {});
    return () => listeners.delete(setB);
  }, []);
  return b;
}
